<template>
  <div class="content">
    <h1 class="has-text-centered">Elektrische Bauelemente</h1>
    <div class="box">
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{ name: 'theory-transformator' }" class="inherited">
                  <div class="p-2">Transformator</div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <h2 class="has-text-centered">Häufige Fragen</h2>
    <div class="box">
      <FAQs :faqs="faqs" />
    </div>
  </div>
</template>

<script>
import FAQs from '@/components/FAQs.vue'

export default {
  name: 'theory-network-engineering',
  components: {
    FAQs
  },
  metaInfo: {
    title: 'Netzwerktechnik | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Lorem Ipsum'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Elektrische Bauelemente', route: 'start' })
  },
  data () {
    return {
      faqs: [
        {
          question: 'Welche elektrischen Bauelemente gibt es?',
          answer: '<p>Elektrische Bauelemente werden in aktive und passive Bauelemente unterteilt.</p><strong>Aktive Bauelemente</strong><ul><li>Transistoren</li><li>Dioden</li><li>Gleichrichter</li><li>Prozessoren/ICs</li><li>LED</li></ul><strong>Passive Bauelemente</strong><ul><li>Kondensatoren</li><li>Potentiometer</li><li>Oszillatoren und Quarze</li><li>Spulen</li><li>Widerstände</li></ul>'
        }
      ]
    }
  }
}
</script>
